<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import { authWellyMethods } from "@/state/helpers";
    import Category from './popup/category'
    import { apiCore }  from '../../../constants'
    import axios from 'axios'
    import router from '../../../router/index'
    import Swal from "sweetalert2"

    export default {
        components: { Layout, PageHeader, Category },
        props: {},
        data() {
            return {
                alias: '',
                address: '',
                lat: null,
                lng: null,
                email: '',
                url: '',
                user:null,
                statusSend:false,
                statusMsg:""
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            async save(){
                this.statusSend = true
                let url = `${apiCore}/api/resto/add/sucursal`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                
                //(2)Create Dish
                let body = {
                    "address":this.address,
                    "lat":this.lat,
                    "lng": this.lng,
                    "userEmail":this.email,
                    "aliasSucursal":this.alias
                }
                this.statusMsg = "Creando solicitud de sucursal..."
                let sucursalCreate = await axios
                .put(url, body, {
                        headers: {'Authorization': tok},
                })

                // eslint-disable-next-line
                //console.log(sucursalCreate.data)

                if (sucursalCreate.data.valid){
                    this.statusMsg = ""
                    this.statusSend = false

                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Solicitud de sucursal creada con éxito.",
                        showConfirmButton: false,
                        timer: 4500
                    });

                    this.returnProfile()
                }
                else{
                    this.statusMsg = ""
                    this.statusSend = false

                    Swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: sucursalCreate.data.msg,
                        showConfirmButton: false,
                        timer: 4500
                    });
                }
                
            },
            returnProfile(){
                 router.push({path:'/welly/profile?title=Este es tu perfil'})
            }
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div v-if='true' class="row">
            <div class="col-md-3">
            </div>
            <div class="col-md-6">
                 <b-card 
                    :header="'Solicitud de cracción de sucursal'"
                    header-text-variant="white"
                    header-tag="header"
                    header-class="resto-nuevos-pedidos"
                    body-class="body-card-welly"
                    >
                    <div class="card-welly">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 text-center">
                                        <h3 class="title-card">
                                            Completa los datos básicos de la sucursal
                                        </h3> 
                                    </div>

                                    <br/><br/><br/>
                                    <!--
                                    <div class=" col-sm-12 col-md-5" style="margin: 10px 0 10px 0;">
                                        <img src="@/assets/images/steps/step1.svg" width="70%"/>
                                    </div>
                                    -->

                                    <div class=" col-sm-12 col-md-12" style="margin: 10px 0 10px 0;">
                                        <b-form-input v-model="alias" type="text" placeholder="Alias"></b-form-input>
                                        <br/>

                                        <b-form-input v-model="address" type="text" placeholder="Dirección"></b-form-input>
                                        <br/>

                                        <b-form-input v-model="lng" type="number" placeholder="Longitud"></b-form-input>
                                        <br/>

                                        <b-form-input v-model="lat" type="number" placeholder="Latitud"></b-form-input>
                                        <br/>

                                        <b-form-input v-model="email" type="text" placeholder="Correo del usuario"></b-form-input>
                                        <br/>

                                        <br/><br/><br/>

                                        <div style="text-align:right;">
                                            <b-button type="submit" variant="outline-secondary" v-show="!statusSend" v-on:click="save()">
                                                Confirmar solicitud
                                            </b-button> 
                                            <div class="text-card" v-show="statusSend">
                                                {{statusMsg}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                 </b-card>
            </div>
            <div class="col-md-3">
                <b-button type="submit" variant="primary" v-on:click="returnProfile()" class="btn-primary">
                    Cancelar
                </b-button>
            </div>
        </div>
        <br/><br/><br/>

        <Category />

    </Layout>
</template>

<style scoped>

</style>